import {
    Box,
    Typography
} from "@mui/material";

import { Issue } from "../../API";
import { PieChart } from "@mui/x-charts";

type IssueSummaryPieChartProps = {
    issues: Array<Issue>;
};
export const IssueSummaryPieChart = ({ issues }: IssueSummaryPieChartProps) => {
    const unresolvedIssueCount = issues.filter(issue => issue.status !== "COMPLETED" && issue.status !== "ARCHIVED").length;
    const resolvedIssueCount = issues.filter(issue => issue.status === "COMPLETED" || issue.status === "ARCHIVED").length;

    if (unresolvedIssueCount === 0 && resolvedIssueCount === 0) {
        return null;
    }

    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Typography fontSize="0.625rem">
                Issues
            </Typography>
            <PieChart
                series={[
                    {
                        data: [
                            {
                                id: "Resolved",
                                value: resolvedIssueCount,
                                color: "#F8B42A",
                                label: `Issues Resolved: ${resolvedIssueCount}`
                            },
                            {
                                id: "Unresolved",
                                value: unresolvedIssueCount,
                                color: "#374957",
                                label: `Issues Remaining: ${unresolvedIssueCount}`
                            }
                        ],
                        innerRadius: 30,
                        outerRadius: 60,
                        cy: 60,
                    }
                ]}
                slotProps={{
                    legend: {
                        direction: "column",
                        position: { vertical: "bottom", horizontal: "middle" },
                        padding: 0,
                        labelStyle: {
                            fontSize: "0.625rem"
                        }
                    }
                }}
                width={200}
                height={200}
                margin={{ right: 5 }}
            />
        </Box>
    );
};